'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecond;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecond.js
// module id = 693
// module chunks = 0